import api from './api';

export function sendPreAdmissionData(data) {
  return api.post(`/api/v1/admissions/`, data);
}

export function optionPreAdmission() {
  return api.options('/api/v1/admissions');
}

/*
{
    date: '2022-02-20',
    fcm_registration_token: 'fcm_registration_token',
    patient: {
      first_name: 'first_name',
      last_name: 'last_name',
      birthdate: '1984-12-12',
      avs_no: 7569999999863,
      insurance_card_no: '11002233445566778899',
      insurances: [
        {
          name: 'Visana Swica Helsana',
          address: {
            street: 'Rue de la assurance',
            number: '109',
            zip_code: '1704',
            city: 'Fribourg'
          }
        }
      ],
      emails: [
        {
          address: 'first.last@domain.com'
        }
      ],
      phones: [
        {
          number: '+41795552211'
        }
      ],
      addresses: [
        {
          street: 'Rue de la Banque',
          number: '1',
          zip_code: '1700',
          city: 'Fribourg'
        }
      ]
    },
    appointment: {
      datetime: '2022-06-20 16:15',
      motive: 'A',
      accident: true,
      site: 'fribourg'
    }
  }
  */
